<template lang="pug">

    form.ui.form(v-on:submit.prevent="submit()")

        //- Step-Navigation
        step-navigation(v-bind:step='1')

        //- Formular

        //- Allgemeine Angaben
        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            general-information-form(
                ref='generalInformationForm'
                v-bind:media-production-user-models='mediaProductionUsers'
                v-bind:person-models='persons'
                v-model='model'
            )

        //- Zusätzliche Angaben
        .ui.top.attached.header Zusätzliche Angaben:
        .ui.bottom.attached.segment
            additional-information-form(
                ref='additionalInformationForm'
                v-bind:company-models='companies'
                v-model='model'
            )

        action-row(save-label='Weiter' v-on:click='cancel()')

</template>

<script>
    import * as R from 'ramda'
    import { handle_multiple_validations } from '@/utils/validate'
    import store from '@/store/index'
    import ActionRow from '@/components/form/ActionRow'
    import StepNavigation from '@/components/companies/StepNavigation'
    import AdditionalInformationForm from '@/components/companies/forms/AdditionalInformation'
    import GeneralInformationForm from '@/components/companies/forms/GeneralInformation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {
        name: 'companies-create-step1-view',

        components: {
            ActionRow, AdditionalInformationForm, GeneralInformationForm, StepNavigation
        },

        beforeRouteEnter(to, from, next) {
            if (from.name !== 'companies/create/step2') {
                store.commit('companies/RESET_DRAFT')
            }

            // Medienproduktioner laden + deren Personen
            // companies/loadAll wird lazy geladen (in AdditionalInformation.vue wenn "Agentur" angehakt)
            store.dispatch('users/loadAllByHasMediaProductionRole').then(users =>
                Promise.all(users.map(user => store.dispatch('persons/loadOne', { id: user.person })))
            ).then(next)
        },

        computed: {

            companies() {
                return store.getters['companies/all']
            },

            isInvalid() {
                return this.$refs.additionalInformationForm.isInvalid ||
                    this.$refs.generalInformationForm.isInvalid
            },

            mediaProductionUsers() {
                return store.getters['users/allByHasMediaProductionRole']
            },

            model: {
                get() { return this.$store.getters['companies/draft'] },
                set(value) { this.$store.commit('companies/REPLACE_DRAFT', { draft: value }) }
            },

            persons() {
                return this.mediaProductionUsers
                    .map(user => store.getters['persons/byId'](user.person))
            }

        },

        created() {
            this.$scrollTo('body')

            // Adresstypen setzen
            this.model = {
                ...this.model,
                address: {
                    ...this.model.address,
                    isBillingAddress: true,
                    isCorrespondenceAddress: true,
                    isShippingAddress: true
                }
            }
        },

        methods: {
            cancel() {
                this.$router.push({ name: 'companies' })
            },

            submit() {
                this.validate().then(R.when(R.equals(true), () => {

                    // Auf zu Step 2!
                    this.$router.push({
                        name: 'companies/create/step2'
                    })

                }))
            },

            validate() {
                return Promise.all([
                    this.$refs.additionalInformationForm.validate(),
                    this.$refs.generalInformationForm.validate(),
                ])
                    .then(handle_multiple_validations(this.$scrollToErrorAndFocus))
            }
        },

        watch: {
            'model.name'(value) {
                let shortcode    = ''

                // Kuerzel ermitteln
                const nameSplits = value.split(' ').filter(split => split.length > 0)
                if (nameSplits.length === 1) {
                    shortcode = value.substring(0, 4).toUpperCase()
                } else if (nameSplits.length === 2) {
                    shortcode = nameSplits[0].substring(0, 2).toUpperCase()
                    shortcode += nameSplits[1].substring(0, 2).toUpperCase()
                } else if (nameSplits.length === 3) {
                    shortcode = nameSplits[0].substring(0, 2).toUpperCase()
                    shortcode += nameSplits[1].substring(0, 1).toUpperCase()
                    shortcode += nameSplits[2].substring(0, 1).toUpperCase()
                } else if (nameSplits.length > 3) {
                    shortcode = nameSplits[0].substring(0, 1).toUpperCase()
                    shortcode += nameSplits[1].substring(0, 1).toUpperCase()
                    shortcode += nameSplits[2].substring(0, 1).toUpperCase()
                    shortcode += nameSplits[3].substring(0, 1).toUpperCase()
                }

                this.model = { ...this.model, shortcode }
            }
        }

    }

</script>
